export const SIGNUP_METHOD = {
  EMAIL: 'email',
  MOBILE: 'mobile',
  EMAIL_AND_MOBILE: 'email_and_mobile',
};

// Some 'status' of settings are boolean strings
export const BOOLEAN_STATUS = {
  TRUE: 'true',
  FALSE: 'false',
};

export const ALL_SUPPORTED_COUNTRIES_STRING = '*';

export const SUPPORTED_COUNTRIES_ALL = [ALL_SUPPORTED_COUNTRIES_STRING];
